export default {
  list: '/v3/transport/list'
}
